<app-spinner-overlay></app-spinner-overlay>
<form [formGroup]="formInfoVsme" appFormContainer [larghezza]="6">
  @if (!isModulo) {
    <div class="radio-cmp" appFormElement [larghezza]="2" [riempi]="true">
      <div class="radio-container">
        <mat-label style="margin-left: 10px">Tipo Azienda</mat-label>
        <div class="eti-check">
          <mat-icon class="info-icon" [appTooltipOverlay]="tooltipTipoAzienda" position="right">
            info_outline
          </mat-icon>
        </div>
      </div>
      <mat-radio-group
        aria-label="Tipo Azienda"
        style="display: flex"
        formControlName="tipoAzienda"
      >
        <mat-radio-button aria-label="Microimpresa" value="MICROIMPRESA">
          Microimpresa
        </mat-radio-button>
        <mat-radio-button aria-label="PMI" value="PMI"> PMI </mat-radio-button>
        <mat-radio-button>Non specificato</mat-radio-button>
      </mat-radio-group>
    </div>
  }
  <div class="chip-forma-giuridica" appFormElement [larghezza]="3" [riempi]="true">
    <mat-form-field style="width: 100%">
      <mat-label>Forma giuridica dell'impresa</mat-label>
      <mat-select formControlName="formaGiuridica" [multiple]="true">
        <mat-optgroup
          *ngFor="let group of formaGiuridicaGroups"
          [label]="group.titolo"
          [disabled]="group.disabled"
        >
          <mat-option
            *ngFor="let formaGiuridica of group.formaGiuridica"
            [value]="formaGiuridica.id"
            [disabled]="formaGiuridica.disabled"
          >
            {{ formaGiuridica.valore }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
    <mat-label>Cod. Nace</mat-label>
    <input
      type="text"
      matInput
      formControlName="codiciNace"
      [matAutocomplete]="nace"
      [readonly]="readonlyCodiceNace()"
    />
    <mat-autocomplete #nace="matAutocomplete" [displayWith]="displayFnNace">
      <mat-option *ngFor="let nace of filteredNace | async | slice: 0 : 20" [value]="nace">
        <b>{{ nace._id }}</b> - {{ nace.desc }}
      </mat-option>
      <div
        *ngIf="this.showAltriRecordDisponibili"
        style="text-align: center; color: #807f7f; margin: 0 10px 0 10px"
      >
        Numero record limitati. Modifica il filtro per restringere la ricerca
      </div>
    </mat-autocomplete>
    @if (this.formInfoVsme.get('codiciNace')?.enabled) {
      <button
        matSuffix
        mat-icon-button
        type="button"
        aria-label="Cancella"
        tabindex="-1"
        matTooltip="Cancella"
        (click)="clearInput('codiciNace', $event)"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </mat-form-field>

  <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
    <mat-label
      >Paese delle operazioni primarie e ubicazione dell'attività o delle attività
      significative</mat-label
    >
    <input
      type="text"
      matInput
      formControlName="paeseOperazioni"
      [matAutocomplete]="paese"
      [readonly]="readonlyCodicePaese()"
    />
    <mat-autocomplete #paese="matAutocomplete" [displayWith]="displayFnPaese">
      <mat-option *ngFor="let paese of filteredPaese | async | slice: 0 : 20" [value]="paese">
        <img alt="" class="flag-option-img" [src]="paese.flag" height="25" />
        <b>{{ paese.countryCode }}</b> - {{ paese.countryName }}
      </mat-option>
      <div
        *ngIf="this.showAltriRecordDisponibili"
        style="text-align: center; color: #807f7f; margin: 0 10px 0 10px"
      >
        Numero record limitati. Modifica il filtro per restringere la ricerca
      </div>
    </mat-autocomplete>

    @if (this.formInfoVsme.get('paeseOperazioni')?.enabled) {
      <button
        matSuffix
        mat-icon-button
        type="button"
        aria-label="Cancella"
        tabindex="-1"
        matTooltip="Cancella"
        (click)="clearInput('paeseOperazioni', $event)"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </mat-form-field>

  <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
    <mat-label>Attivo stato patrimoniale</mat-label>
    <input
      matInput
      placeholder="Stato Patrimoniale"
      formControlName="statoPatrimoniale"
      type="number"
      appInputNumber
      inputmode="numeric"
      min="0"
      (keydown)="onKeyDownDip($event)"
    />
    <mat-icon matPrefix>€</mat-icon>
    <mat-error appFormError></mat-error>
  </mat-form-field>
</form>
@if (tabellaSiti) {
  <div appFormElement [larghezza]="4" [riempi]="true" style="margin-bottom: 5px">
    <div class="titolo-sezione-dialog">Geolocalizzazione di siti di proprietà</div>
  </div>
  <app-tabella-cfg-dinamica
    #cfgTabellaDinamica
    [tabella]="tabellaSiti"
    [disabilitaCelle]="disableForm"
    [disabilitaHeaderRC]="disableForm"
    [nascondiBottoni]="disableForm"
  ></app-tabella-cfg-dinamica>
}

<ng-template #tooltipTipoAzienda>
  <div>
    <ul style="padding-left: 1rem; margin: 0">
      <li>
        <span style="color: var(--mat-color-accent); font-weight: 600">Microimpresa</span><br />
        <span style="font-weight: 500; font-size: 13px">
          Un'impresa è considerata micro se non supera due delle seguenti soglie:
        </span>
        <ul style="padding-left: 1.2rem; margin: 0.3rem 0; font-size: 12px">
          <li>450.000 € di totale di bilancio</li>
          <li>900.000 € di fatturato netto</li>
          <li>Media di 10 dipendenti</li>
        </ul>
      </li>
      <li style="margin-top: 0.8rem">
        <span style="color: var(--mat-color-accent); font-weight: 600">Piccola impresa</span><br />
        <span style="font-weight: 500; font-size: 13px">
          Un'impresa è considerata piccola se non supera due delle seguenti soglie:
        </span>
        <ul style="padding-left: 1.2rem; margin: 0.3rem 0; font-size: 12px">
          <li>5 milioni € di bilancio complessivo</li>
          <li>10 milioni € di fatturato netto</li>
          <li>Media di 50 dipendenti</li>
        </ul>
      </li>
      <li style="margin-top: 0.8rem">
        <span style="color: var(--mat-color-accent); font-weight: 600">Media impresa</span><br />
        <span style="font-weight: 500; font-size: 13px">
          Un'impresa è considerata media se non supera due delle seguenti soglie:
        </span>
        <ul style="padding-left: 1.2rem; margin: 0.3rem 0; font-size: 12px">
          <li>25 milioni € di totale di bilancio</li>
          <li>50 milioni € di fatturato netto</li>
          <li>Media di 250 dipendenti</li>
        </ul>
      </li>
    </ul>
  </div>
</ng-template>
